import React from "react";

function SearchIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                stroke="var(--color-highlight)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M14.651 7.82a6.825 6.825 0 01-6.825 6.82A6.825 6.825 0 011 7.82c0-1.725.64-3.305 1.701-4.505A6.825 6.825 0 0114.646 7.82h.005zM19 19l-4.944-4.945"
            ></path>
        </svg>
    );
}

export default SearchIcon;
